'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from '@/i18n/routing';
import {
  clearActiveLiveCallSession,
  getLiveDetailIdFromPathname,
  triggerActiveLiveCallSessionLeave,
} from '../_utils/live-call-session';

export const LiveSessionLifecycleWatcher = () => {
  const pathname = usePathname();
  const currentLiveIdRef = useRef<string | null>(getLiveDetailIdFromPathname(pathname));

  const triggerLeave = (liveId: string, reason: 'route_change_leave' | 'pagehide_leave') => {
    triggerActiveLiveCallSessionLeave({ liveId, reason });

    clearActiveLiveCallSession(liveId);
    currentLiveIdRef.current = null;
  };

  useEffect(() => {
    const nextLiveId = getLiveDetailIdFromPathname(pathname);
    const previousLiveId = currentLiveIdRef.current;

    if (previousLiveId && previousLiveId !== nextLiveId) {
      triggerLeave(previousLiveId, 'route_change_leave');
    }

    currentLiveIdRef.current = nextLiveId;
  }, [pathname]);

  useEffect(() => {
    const handlePopState = () => {
      const liveId = currentLiveIdRef.current;
      if (!liveId) {
        return;
      }

      triggerLeave(liveId, 'route_change_leave');
    };

    const handlePageHide = () => {
      const liveId = currentLiveIdRef.current;
      if (!liveId) {
        return;
      }

      triggerLeave(liveId, 'pagehide_leave');
    };

    window.addEventListener('popstate', handlePopState);
    window.addEventListener('pagehide', handlePageHide);

    return () => {
      window.removeEventListener('popstate', handlePopState);
      window.removeEventListener('pagehide', handlePageHide);
    };
  }, []);

  return null;
};
